import api from '../http';
import { AxiosResponse } from 'axios';
import { GetCurrencyInfoResponse } from '../models/currency';


export default class CurrencyService {
    static async get(): Promise<AxiosResponse<GetCurrencyInfoResponse>> {
        return await api.get('currency');
    };
};